import axios from 'axios'
import * as R from 'ramda'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import hostConf from '$config/frontend'
import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { ShareReqPayload } from '@weblite-wapps/protocol'
import { getClientUserIdentityToken } from '$logic/auth'
import { shareInlineWapp } from '$logic/wapp-communication/helper/utils.helper'
import { showProcessingMessageLoadingModal } from '$comp/modals/loading-modal'
import { sendImageMessage, sendTextMessage } from '$logic/message/service'
import { blobToFile } from '$func/file'
import {
  showGeneratingImageFailedSnackbar,
  showGeneratingTextFailedSnackbar,
} from '$comp/snackbars'

const LINK_REGEX_STRING =
  '([a-z]+:\\/\\/)?((([^\\s./?#]+\\.)+[^\\s./]+)(\\/\\S*)?)$'

const LINK_REGEX = new RegExp(LINK_REGEX_STRING, 'g')

const MESSAGE_BODY_SIZE_LIMIT = 4096

const PLUGINS = [
  {
    match: new RegExp(`^\/ask ((.|\n)+)$`),
    handle: async (body: string, roomId: string, chatType: string) => {
      if (!hostConf.ASK_PLUGIN_SERVER) return false
      const question = body.slice(5)
      if (!question.length) return false

      try {
        axios
          .post<{ response: string }>(hostConf.ASK_PLUGIN_SERVER, {
            question,
          })
          .then(async res => {
            const text = res.data.response
            if (!text) return

            const messageText = `${question}:\n${text}`

            const messages = R.splitEvery(
              MESSAGE_BODY_SIZE_LIMIT,
              messageText,
            ).filter(txt => Boolean(txt.trim()))

            messages.forEach(message => {
              sendTextMessage(message, undefined, roomId, chatType)
            })
          })
          .catch(() => {
            showGeneratingTextFailedSnackbar()
          })
      } catch (e) {
        console.error(e)
      }

      return false
    },
  },
  {
    match: new RegExp(`^\/meq ((.|\n)+)$`),
    handle: async (body: string, roomId: string) => {
      if (!hostConf.MEQIAS_PLUGIN_SERVER) return false

      const prompt = body.slice(5)
      if (!prompt.length) return false

      try {
        axios
          .post<{ image_url: string }>(hostConf.MEQIAS_PLUGIN_SERVER, {
            prompt,
            seed: '123',
          })
          .then(async res => {
            const imageUrl = res.data?.image_url
            if (!imageUrl) return

            const { data } = await axios.get(imageUrl, {
              responseType: 'blob',
            })
            const imageFile = blobToFile(data, 'generated_image.jpg')

            await sendImageMessage(imageFile, prompt, undefined, roomId)
          })
          .catch(() => {
            showGeneratingImageFailedSnackbar()
          })
      } catch (e) {
        console.error(e)
      }

      return false
    },
  },
  {
    match: new RegExp(`/post( +)${LINK_REGEX_STRING}`),
    handle: async (body: string) => {
      if (!hostConf.POST_COMMAND_PLUGIN_SERVER) return false

      const link = body.match(LINK_REGEX)?.[0]
      const token = await getClientUserIdentityToken()

      await showProcessingMessageLoadingModal()
      try {
        const res = await axios.post<ShareReqPayload>(
          `${hostConf.POST_COMMAND_PLUGIN_SERVER}/link`,
          { link },
          { headers: { authorization: `Bearer ${token}` } },
        )

        await shareInlineWapp(
          res.data.inlineModeInfo,
          false,
          res.data.contentUri,
        )
        closeCurrentModal()
        return true
      } catch (e) {
        closeCurrentModal()
        console.error(e)
        return false
      }
    },
  },
] as const

export async function handleCommandInMessage(
  body: string,
  roomId: string,
  chatType: string,
) {
  const plugin = PLUGINS.find(p => p.match.test(body))

  if (!plugin) return false

  return plugin.handle(body, roomId, chatType)
}
